import { Id, TextField } from "@dgs/core";
import { ReactNode } from "react";
import {
	ContactAttributeRequest,
	IContactAttributeBaseHandler,
	IContactAttributeHandler,
	IContactAttributeListHandler,
} from "../IContactAttributeHandler";

export function createLastNameContactAttributeBaseHandler(id: Id): IContactAttributeBaseHandler {
	return {
		type: "LAST_NAME",
		id,
		getLabel: (t) => t("Lastname"),
	};
}

export function createLastNameContactAttributeProfileHandler(
	id: Id,
	value: string | null,
): IContactAttributeHandler<string, string | null> {
	const baseHandler = createLastNameContactAttributeBaseHandler(id);
	return {
		...baseHandler,
		value,
		validate() {
			return null;
		},
		renderValue(): ReactNode {
			return this.value ?? "";
		},
		renderFormField(t, prefix): ReactNode {
			return <TextField name={`${prefix ? `${prefix}.` : ""}${id}.value`} label={baseHandler.getLabel(t)} />;
		},
		toRequestValue(): ContactAttributeRequest<string> {
			return { id, value: this.value ?? "" };
		},
	};
}

export function createLastNameContactAttributeListHandler(id: Id): IContactAttributeListHandler {
	const baseHandler = createLastNameContactAttributeBaseHandler(id);
	return {
		...baseHandler,
		getColumnSize: () => "1fr",
	};
}
